'use client'

import { useEffect, type PropsWithChildren } from 'react'
import { useWebHaptics } from 'web-haptics/react'

type HapticStyle =
  | 'light'
  | 'medium'
  | 'heavy'
  | 'selection'
  | 'success'
  | 'warning'
  | 'error'

export function HapticsProvider({ children }: PropsWithChildren) {
  const { trigger } = useWebHaptics()

  useEffect(() => {
    const validStyles: HapticStyle[] = [
      'light',
      'medium',
      'heavy',
      'selection',
      'success',
      'warning',
      'error',
    ]

    function clickHandler(e: MouseEvent) {
      if (!(e.target instanceof Element)) {
        return
      }
      const el = e.target.closest('[data-haptic]')
      const style = el?.getAttribute('data-haptic')
      if (style && (validStyles as string[]).includes(style)) {
        trigger(style as HapticStyle)
      }
    }

    document.addEventListener('click', clickHandler)
    return () => document.removeEventListener('click', clickHandler)
  }, [trigger])

  return <>{children}</>
}
